import React, { useEffect, useState } from 'react'
import style from './style.module.sass'
import logo from './assets/group372.svg'
import logoBW from './assets/group372-bw.svg'
import text from './assets/TEXTLAB-LOGIN.svg'
import textBW from './assets/TEXTLAB-LOGIN-bw.svg'
import submitIcon from './assets/anmeldenIcon.svg'
import { TextField } from '@material-ui/core'
import Footer from '../Footer/Footer'
import { useTheme } from '@material-ui/core/styles'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { Alert } from '@material-ui/lab'
import ResetModal from './ResetModal/ResetModal'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import TLServiceComponent from '../../contexts/TLServiceComponent'
import { useActions } from '../../utils/action-helper'
import { loginUser, loginUserLDAP, loginUserSSO } from '../../actions'
import { Redirect, useRouteMatch } from 'react-router-dom'
import Spinner from '../Spinner'
import { convertFromErrorObject, isObjectEmpty, muiNoOutline, parseErrorObject } from '../../utils'
import RestoreModal from './RestoreModal/RestoreModal'
import config from '../../config'
import ThemeHandler from '../Main-page-wrapper/Header/ThemeHandler/ThemeHandler'
import bgImageDark from './assets/dark-bg.png'
import bgImage from './assets/square728.png'
import bgImgBW from './assets/bw-bg.png'
import { Error } from '@material-ui/icons'

export default function AuthForm () {
  const { t, i18n } = useTranslation()
  const { theme: { bgColors, borderColors, colors } } = useTheme()
  const { params: { code } } = useRouteMatch()

  const search = window.location.search
  const params = new URLSearchParams(search)
  const error = params.get('error')

  // states
  const [submitted, setSubmitted] = useState(false)
  const [openAlert, setOpenAlert] = useState('')
  const [openResetPass, setOpenPass] = useState(false)
  const [openRestorePass, setOpenRestorePass] = useState(!!code)
  const [toggle, setToggle] = useState(false)
  const [totpRedirect, setTotpRedirect] = useState('')

  // get reducers
  const errorUser = useSelector(state => state.userData.error)
  const token = useSelector(state => state.userData.token)
  const thinclient = useSelector(state => state.openData.ping?.thinclient)
  const serviceExport = useSelector(state => state.openData.ping?.serviceExport || {})
  const autoLogin = useSelector(state => state.openData.ping?.autoLogin || false)
  const ssoRedirect= useSelector(state => state.userData.ssoRedirect)

  let theme = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = theme !== config.THEMES_MODES.LIGHT
  const classes = muiNoOutline()
  const [autoLoginIndex, setAutoLoginIndex] = useState(0)

  // bind actions
  const tlService = React.useContext(TLServiceComponent)
  const { actionLoginUser, actionLoginUserLDAP, actionLoginUserSSO } = useActions({
    actionLoginUser: loginUser(tlService, i18n),
    actionLoginUserLDAP: loginUserLDAP(tlService, i18n),
    actionLoginUserSSO: loginUserSSO(tlService, i18n),
  })

  const bgImg = theme === config.THEMES_MODES.CONTRAST_DARK ? bgImageDark : theme === config.THEMES_MODES.CONTRAST_LIGHT ? bgImgBW : bgImage
  const logoImg = theme === config.THEMES_MODES.CONTRAST_LIGHT ? logoBW : logo
  const textImg = theme === config.THEMES_MODES.CONTRAST_LIGHT ? textBW : text

  const authFunctions = {
    'LDAP': actionLoginUserLDAP,
    'Shibboleth': actionLoginUserSSO,
    'EntraID': actionLoginUserSSO
  }

  //state validation by YUP
  const validationSchema = yup.object({
    name: yup.string()
      .required(t('Required field')),
    password: yup.string()
      .required(t('Required field')),
  })

  const formik = useFormik({
    initialValues: {
      name: '',
      password: '',
      adoption: false,
      language: '',
      textSort: '',
    },
    validationSchema: validationSchema,
    onSubmit: ({ name, password }) => {
      setSubmitted(true)
      setOpenAlert('')
      actionLoginUser(name, password, true)
      // add true to remember!!
    },
  })

  useEffect(() => {
     if (error){
       setOpenAlert(error)
     }
  }, [])


  // auto login sequence
  useEffect(() => {
    if (!isObjectEmpty(serviceExport)) {
      const servicesArray = Object.entries(serviceExport)
      if (!token && autoLogin && (autoLoginIndex === 0 || !!errorUser) && autoLoginIndex < servicesArray.length) {
        // try to log in with all enabled services
        const servAutoLogin = servicesArray[autoLoginIndex][1]?.auto_login
        if (!submitted && autoLoginIndex < servicesArray.length && servAutoLogin) {
          // try to connect
          console.log('try', servicesArray[autoLoginIndex])
          setSubmitted(true)
          const serviceId = servicesArray[autoLoginIndex][1]['service_id']
          if (servicesArray[autoLoginIndex][0].includes('LDAP')) {
            actionLoginUserLDAP(serviceId, false)
          } else if (!servicesArray[autoLoginIndex][0].includes('Local')) {
            actionLoginUserSSO(serviceId, false)
          }
          setAutoLoginIndex(autoLoginIndex + 1)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, serviceExport, errorUser, submitted])

  // effect check error user login
  useEffect(() => {
    if (!!errorUser) {
      const data = parseErrorObject(errorUser)
      if (submitted) {
        // fo GA temporary
        if (data?.type_2fa === 'ga') {
          setSubmitted(false)
          setTotpRedirect('/authorization/2fa/ga')
          return
        }
      }
      setSubmitted(false)
      setOpenAlert(convertFromErrorObject(t, errorUser))
    }
    // eslint-disable-next-line
  }, [errorUser])

  // Check for LDAP value:
  useEffect(() => {
    if (!isObjectEmpty(serviceExport)) {
      for (let el of Object.keys(serviceExport)) {
        if (el.includes('LDAP') || el.includes('Shibboleth')) {
          setToggle(true)
          break
        }
      }
    }
  }, [serviceExport])

  const handleDifferentLoginTypes = async (extraValues, service) => {
    setSubmitted(true)
    setOpenAlert('')
    if (Object.keys(authFunctions).includes(service)) {
      authFunctions[service](extraValues['service_id'], false)
    }

  }

  console.log('ssoRedirect', ssoRedirect)
  if (ssoRedirect){
    window.location.href = ssoRedirect;
    return null;
  }

  if (totpRedirect) {
    return <Redirect to={totpRedirect}/>
  }

  if (token && !openRestorePass) {
    return <Redirect to="/"/>
  }

  return (
    <div style={{ backgroundColor: bgColors.bgPrimary100 }} className={style.mainCont}>
       <div style={{ position: 'absolute', top: 20, right: 20, zIndex: 100}}>
        <ThemeHandler />
      </div>
      {submitted && <Spinner themeState={theme}/>}
      <ResetModal setOpen={setOpenPass} open={openResetPass}/>
      <RestoreModal setOpen={setOpenRestorePass} open={openRestorePass}/>
      <form onSubmit={formik.handleSubmit} className={style.form}>
        <div style={{ boxShadow: '0 0 5px rgba(0, 0, 0, 0.161)', backgroundColor: bgColors.bgPrimary0 }}>
          <div className={style.blueRec} style={{backgroundImage: `url(${bgImg})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'contain'}}>
            <img src={logoImg} className={style.logo} alt="logo" title={t('accessibility_login_logo')}/>
            <img src={textImg} className={style.text} alt="text"/>
          </div>
          <div className={style.fields}>
            {!!openAlert && <Alert
              className={`mb-1`} 
              style={{ backgroundColor: bgColors.bgModalError, color: colors.colorStatusError}} iconMapping={{error: <Error style={{ color: colors.colorStatusError }} />}}
              severity="error">
              <p className={`m-0`} title={t('accessibility_login_alert')} >{openAlert}</p>
            </Alert>}
            {toggle ?
              <div>
                <div className={`${style.fieldsActions} mb-3`}>
                  <p style={{ color: colors.colorMutedText, textAlign: 'center' }}
                     dangerouslySetInnerHTML={{ __html: t('login-top-toggle-text') }}/>
                </div>
                <br/>
                <div className={`${style.submitCont} mt-2 mb-3`} style={{ paddingBottom: '170px', justifyContent: 'space-between'}} >
                  {!isObjectEmpty(serviceExport) && Object.entries(serviceExport).map(([key, value]) => {
                      if (key !== 'Local') {
                        return (
                          <div key={key} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 5px', width: 'fit-content', minWidth: '160px' }}>
                            <button type="submit" className={style.submitEasyStart} style={{ backgroundColor: bgColors.bgLoginService, color: colors.colorWhite, width: '100%' }} onClick={() => handleDifferentLoginTypes(value, key)}>
                              <img src={submitIcon} alt="submit svg" />
                              {t('lets-start-with-service {{service}}', { service: key })}
                            </button>
                            <span style={{ marginTop: '8px', fontSize: '12px', lineHeight: '16px', color: colors.colorMutedText, textAlign: 'center', width: '100%', maxWidth: '100%', wordBreak: 'break-word' }}>{t(`login-service-footer-text ${key}`)}</span>
                          </div>
                        )
                      }
                    }
                  )}
                </div>
                <p style={{ color: colors.colorMutedText, textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                  setToggle(false)
                }}>
                  {t('redirect-login')}
                </p>
              </div> :
              <>
                <TextField
                  helperText={formik.touched.name && formik.errors.name}
                  error={formik.touched.name && !!formik.errors.name}
                  classes={isContrast ? { root: classes.root } : {}}
                  onChange={formik.handleChange}
                  name={'name'}
                  variant="filled"
                  label={t('Login or e-mail')}
                  style={{ marginBottom: '30px' }}
                  title={t('accessibility_login_email')}
                  tabIndex={config.tabIndexes.username}
                  InputProps={{ style: { color: colors.colorText, backgroundColor: bgColors.bgMuted }}} InputLabelProps={{ style: { color: colors.colorMutedText }}}
                />
                <TextField
                  type="password"
                  helperText={formik.touched.password && formik.errors.password}
                  error={formik.touched.password && !!formik.errors.password}
                  classes={isContrast ? { root: classes.root } : {}}
                  onChange={formik.handleChange}
                  name={'password'}
                  className={`mt-3`}
                  variant="filled"
                  label={t('Password')}
                  style={{ marginBottom: '20px' }}
                  title={t('accessibility_login_password')}
                  tabIndex={config.tabIndexes.password}
                  InputProps={{ style: { color: colors.colorText, backgroundColor: bgColors.bgMuted }}} InputLabelProps={{ style: { color: colors.colorMutedText }}}
                />
                {thinclient ? <p
                  style={{ color: colors.colorMutedText }}
                  className={`${style.password}`}
                  tabIndex={config.tabIndexes.forgetPassword}
                  title={t('accessibility_login_forgot-password')}
                  onClick={() => {
                    setOpenPass(!openResetPass)
                  }}>
                  {t('Forgot Your Password?')}
                </p> : null}
                <div>
                  <div className={`${style.submitCont} mb-4`} tabIndex={config.tabIndexes.loginButton} >
                    <button type="submit" className={style.submit} key={'Local'}  title={t('accessibility_login_submit-button')} style={{
                      backgroundColor: bgColors.bgProgress100, color: colors.colorWhite, border: theme === config.THEMES_MODES.CONTRAST_DARK ? `1px solid ${borderColors.borderPrimary300}` : 'none'}}>
                      <img src={submitIcon} alt="login icon"/>
                      {t('Login')}
                    </button>
                  </div>
                  <div className={`${style.submitCont}  mb-0`}>
                    {!isObjectEmpty(serviceExport) && Object.entries(serviceExport).map(([key, value]) => {
                      if (key !== 'Local') {
                        return (
                          <button type="submit" className={style.submitEasyStart} style={{backgroundColor: bgColors.bgLoginService, color: colors.colorWhite}} onClick={() => handleDifferentLoginTypes(value, key)}>
                            <img src={submitIcon} alt="submit svg"/>
                            {t('lets-start-with-service {{service}}', { service: key })}
                          </button>
                        )
                      }
                    })}
                  </div>
                </div>
                <div className={`${style.fieldsActions} `}>
                  <div style={{ borderColor: borderColors.borderPrimary300 }} className={style.news}>
                    <p dangerouslySetInnerHTML={{ __html: t('Login Page Bottom Text') }}
                       style={{ color: colors.colorMutedText, textAlign: 'center' }} title={t('accessibility_login_bottom-text')}/>
                  </div>
                </div>
              </>
            }
          </div>
        </div>
        <div className={`pt-1`}>
          <Footer/>
        </div>
      </form>
    </div>
  )
}

